import React from "react";
import "../css/privacy.scss";
import siteConfig from "../siteConfig";

function Cookies() {
  return (
    <main className="policy">
      <header><p>YOUR BROWSING CHOICES</p><h1>Cookie policy</h1></header>
      <article>
        <p>Last updated September 2026</p>
        <h2>What cookies are</h2>
        <p>Cookies and similar browser storage are small files or records used to remember information during and between visits.</p>
        <h2>Essential storage</h2>
        <p>We use essential browser storage to keep your bag, wishlist and checkout journey working. These functions cannot be switched off through the site.</p>
        <h2>Analytics and preferences</h2>
        <p>If optional analytics or preference tools are introduced, they will be used to understand site performance and remember choices. Where required, we will ask for consent first.</p>
        <h2>Managing cookies</h2>
        <p>You can delete or block cookies in your browser settings. Blocking essential storage may prevent the bag and checkout from working correctly.</p>
        <h2>Questions</h2>
        <p>Questions about this policy can be sent to <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>.</p>
      </article>
    </main>
  );
}

export default Cookies;
